module.exports = __webpack_public_path__ + "static/media/no-connection.81e05fc2.svg";